module.exports = __webpack_public_path__ + "static/play-b35d2c5477050214f6bf112dbb6637d8.jpg";